module.exports = __webpack_public_path__ + "static/media/align-right.9cea55bd.svg";